// extracted by mini-css-extract-plugin
export default {"link":"FqctZ4zVAqDSOhgWRUuf","link_item":"yE3uXfa5Ijf0eTtRTius","navbar_link":"BxkSWxS3SF4yLsrZki7A"};